import React from "react";
import "./giftCard.scss";
import GCBanner from "./Banner/GCBanner";
import GiftAnyAmount from "./GiftAnyAmount";
import GiftMemberships from "./GiftMemberships/GiftMemberships";
import BestServices from "./BestServices";
import AllServices from "./AllServices/AllServices";

const GiftCard = () => {
  return (
    <div className="GiftCardMain">
      <GCBanner />
      <GiftMemberships />
      <GiftAnyAmount />
      <BestServices />
      <AllServices />
    </div>
  );
};

export default GiftCard;
